import {useNavigate} from "react-router";
import {useQuery} from "react-query";
import DataTable from "react-data-table-component";
import { DataGrid, GridColDef, GridToolbar, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';
import moment from "moment";
import {useParams, useSearchParams} from "react-router-dom";
import http from "../../../Services/Network/http";

export const AdminOrders = () => {
    const {period} = useParams();
    const navigate = useNavigate();
    const [queryParams] = useSearchParams();

    const { data: user } = useQuery(
        ["fetchUser", queryParams.get("UserId")],
        () => http.get(`/User/${queryParams.get("UserId") }`),
        { enabled: queryParams.get("UserId") !== null })

    const { data: orders } = useQuery(
        ["fetchOrders", queryParams.get("UserId")],
        () => http.get(queryParams.get("UserId") !== null ? `/Order?userId=${queryParams.get("UserId")}` : `/Order`));

    const columns : GridColDef[] = [
        {
            headerName: 'Ordre.Nr',
            field: 'orderId',
            sortable: true,
            flex: 0.5
        },
        {
            headerName: 'Status',
            field: 'orderStatus',
            valueGetter: (params: any) => params?.title,
            sortable: true,
            flex: 0.8
        },
        {
            headerName: 'Bestiller',
            field: 'createdByUser',
            valueGetter: (params: any) => params?.fullName,
            sortable: true,
            flex: 1
        },
        {
            headerName: 'Ansatt.Nr',
            field: 'username',
            valueGetter: (value: any, row: any ) => row?.createdByUser?.username,
            sortable: true,
            flex: 1
        },
        {
            headerName: 'Leverandør',
            valueGetter: (params: any) => params?.name,
            field: 'supplier',
            sortable: true,
            flex: 0.6,
            
        },
        {
            headerName: 'Opprettet',
            field: 'createdAt',
            valueFormatter: (value) => moment(value).format('DD.MM.yyyy HH:mm'),
            sortable: true,
            flex: 1,
        }
    ];

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <div style={{ flex: 1 }} />
                <GridToolbarQuickFilter debounceMs={150} />
            </GridToolbarContainer>
        );
    }

    return (
        <div>
            <h2 style={{ float: 'left' }}>Admin {user !== undefined ? (<>&gt; User &gt; {user?.fullName} </>) : null} &gt; Ordreliste</h2>
            <div className="clearfix"></div>
            <DataGrid
                pageSizeOptions={[10, 20, 25, 50, 100]}
                density="compact"
                pagination={true}
                columns={columns}
                slots={{ toolbar: CustomToolbar }}
                onRowClick={(data) => navigate(`/admin/order/${data.row.orderId}`)}
                initialState={{
                    pagination: { paginationModel: { pageSize: 20 } },
                    columns: {
                        columnVisibilityModel: {
                            username: false,
                        },
                    },
                }}
                
                getRowId={(row) => row.orderId}
                rows={(orders || []).filter((order : any) => { 
                    if(period === undefined) 
                        return order 
                    else if(new Date(order.createdAt).getFullYear() === parseInt(period ?? "")) 
                        return order
                    return []
                })}
            />
        </div>
    );
}